import {isAvailabiltyRoute, isRescheduleRoute} from '../../utils/isRoute';
import {createContext} from 'react';
import {Reschedule, Availability} from '../../pages';
import {useRouteContext} from './RouteProvider';

type RouterContext = {
  isAvailabiltyRoute: boolean;
  isRescheduleRoute: boolean;
};

const RouterContext = createContext<RouterContext | null>(null);

export const Router = () => {
  if (isAvailabiltyRoute()) {
    return <Availability />;
  }
  if (isRescheduleRoute()) {
    return <Reschedule />;
  }
  return null;
};

export const RouteAvailability = ({
  children,
}: {
  children: React.ReactElement;
}) => {
  const context = useRouteContext();
  if (context.isAvailabiltyRoute) {
    return children;
  }
  return null;
};

export const RouteReschedule = ({children}: {children: React.ReactElement}) => {
  const context = useRouteContext();
  if (context.isRescheduleRoute) {
    return children;
  }
  return null;
};
